import background from "./images/HAND/background.png";
import handLogo from "./images/HAND/logo.png";
import ranLogo from "./images/logo-with-text-pink.png";

type CityConfig = {
  logo: any;
  bannerClass: string;
  background?: any;
  link: string;
  coords: [number, number];
  announcement: string;
  joinTitle: string;
  joinText: string;
};

class Config {
  constructor(
    public MAPBOX_TOKEN: string,
    public MAPBOX_STYLE: string,
    public OREGON_BBOX: [number, number, number, number],
    public STATE_NAMES: string[],
    public CITIES: string[],
    public CITY: string,
  ) {}

  configs = {
    EUGENE: {
      logo: handLogo,
      bannerClass: "gray",
      background,
      link: "https://eugenehand.org/",
      coords: [-123.0897, 44.0521],
      announcement: "With data for all of Lane County!",
      joinTitle: "Join Housing and Neighborhood Defense!",
      joinText: "We can help you start organizing with neighbors in your area.",
    },
    PDX: {
      logo: ranLogo,
      bannerClass: "pink",
      link: "https://ranpdx.org/",
      coords: [-122.676483, 45.523064],
      announcement:
        "Now works in Multnomah, Washington, and Clackamas counties!",
      joinTitle: "Join Renters Action Network!",
      joinText:
        "We can help you start a tenant union in your building or connect you with someone who already has",
    },
  } as { [city: string]: CityConfig };

  get(key: keyof CityConfig) {
    return this.configs[this.CITY][key];
  }
}

export const config = new Config(
  "pk.eyJ1IjoibXNnc2x1dCIsImEiOiJja2NvZmFpbjAwMW84MnJvY3F1d2hzcW5nIn0.xMAHVsdszfolXUOk9_XI4g",
  "mapbox://styles/msgslut/cmj3ye2ze002501szbtzs16o5",
  [
    -124.55417836738366, 41.99161889477894, -116.46390970729706,
    46.26801803457034,
  ],
  ["OREGON", "OR"],
  ["EUGENE", "PDX"],
  window.location.href.toUpperCase().includes("PDX") ? "PDX" : "EUGENE",
);
